import React from 'react';
import './Dashboard.scss';


const Dashboard = () => {
    return (
        <div className="dashboard">
            <div className="card">
                <div className="titulo">Em desenvolvimento</div>
                <div className="body">Estamos trabalhando nessa página</div>
            </div>
            
        </div>
    );
};

export default Dashboard;